import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid/Grid";
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles({
    grid: {
        width: 250,
        marginLeft: 20,
    },
    input: {
        width: 200
    },
    formControl: {
        width: '100%'
    },
    searchBtn: {
        borderBottom: '1px solid #3f51b4',
        borderRight: '1px solid #3f51b4',
        color: '#3f51b4',
        padding: '3px 5px 0px 5px',
        cursor: 'pointer',
        fontSize: '0.8rem',
        display: 'inline-block',
        marginTop: 16,
        position: 'relative',
        '&::before': {
            boxSizing: 'inherit',
            content: '""',
            position: 'absolute',
            borderTop: '1px solid transparent',
            borderLeft: '1px solid transparent',
            width: '0',
            height: 0,
            top: 0,
            left: 0,
        },
        '&:hover': {
            '&::before': {
                width: '100%',
                height: 30,
                borderTopColor: '#3849a4',
                borderLeftColor: '#3849a4',
                transition: 'width 0.15s ease-out, height 0.15s ease-out 0.15s'
            },
        }
    }
});

export default function SearchDesktop(props) {

    const [open, setOpen] = React.useState(true);

    const [search, setSearch] = React.useState(props.filter.params.options);

    const inputRef = React.createRef();

    const classes = useStyles();

    const params = props.filter.params;

    const filter = props.filter;

    const handleSearchChange = (e) => {
        e.preventDefault();
        params.options = inputRef.current ? inputRef.current.value : null;
        filter.dispatchFilter();
    };

    const handleSearchInput = (e) => {
        setSearch(e.target.value);
    };

    const handleOpenClick = () => {
        setOpen(!open);
    };

    filter.addDispatchCallback('searchDesktop', () => {
        if (inputRef.current) {
            setSearch(params.options);
        }
    });

    return (<>
        <div className={props.classes.block}>
            <div className={props.classes.opener} onClick={handleOpenClick}>
                {open ? <RemoveIcon/> : <AddIcon/>}
            </div>
            <div className={props.classes.blockHeader} onClick={handleOpenClick}><Typography><b>Search</b></Typography></div>
            {open ? <div className={props.classes.makes}><div className={props.classes.makesCont}>
                <form onSubmit={handleSearchChange}>
                <Grid container className={classes.grid}>
                    <Grid item className={classes.input}>
                        {params.options !== null ? <TextField
                            id="search"
                            label={"Search"}
                            helperText="Options, VIN, Stock, etc..."
                            maxLength={255}
                            inputRef={inputRef}
                            value={search}
                            onChange={handleSearchInput}
                        /> : null}
                        {params.options === null ? <TextField
                            id="search2"
                            label={"Search"}
                            helperText="Options, VIN, Stock, etc..."
                            maxLength={255}
                            inputRef={inputRef}
                        /> : null}
                    </Grid>
                    <Grid item className={classes.btn}>
                        <div className={classes.searchBtn} onClick={handleSearchChange}>
                            <SearchIcon className={classes.searchIcon}/>
                        </div>
                    </Grid>
                </Grid>
                </form>
            </div></div> : null}
        </div>
    </>)
}